import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';


class PagerEx extends Component {

  onPageChange = (page) => {
    this.props.onPageChange(page.selected);
  };

  render() {
    return (
        <div className="ui-pagination noselect" >
          <ReactPaginate {...this.props} pageClassName="ui-pagination-list-item"
            containerClassName="ui-pagination-list"
            activeClassName="ui-pagination-list-item--active"
                         previousClassName="ui-pagination-text"
                         nextClassName="ui-pagination-text"
                         breakClassName="ui-pagination-list-item"
                         nextLabel="&gt;" previousLabel="&lt;"
                         onPageChange={this.onPageChange}
            />
        </div>
    )
  }
}

PagerEx.propTypes = {
  onPageChange: PropTypes.func.isRequired,
  pageCount: PropTypes.number.isRequired,
  forcePage: PropTypes.number
};

export default PagerEx;


